export enum ManageBookingRoutes {
  Index = '/manage-bookings',
}
